import map from 'lodash/map';
import memoize from 'memoize-one';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import React from 'react';

import { optionShape } from '../../prop-types';
import getDatasetFromProps from '../../utils/get-dataset-from-props';
import MultiSelect from '../MultiSelect';
import GroupHeading from './GroupHeading';
import ValueContainer from './ValueContainer';

function groupSelection(values, options) {
  return options.map(group => ({
    label: group.label,
    options: group.options.length,
    selected: group.options.filter(option => values.includes(option.value))
      .length,
  }));
}

function withoutGroup(values, group) {
  const groupValues = map(group.options, 'value');
  return values.filter(value => !groupValues.includes(value));
}

function withGroup(values, group) {
  const newlySelected = map(group.options, 'value');
  const outOfGroupSelection = withoutGroup(values, group);
  return outOfGroupSelection.concat(newlySelected);
}

class GroupSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleGroupSelect = this.handleGroupSelect.bind(this);

    this.groupSelection = memoize(groupSelection);
  }

  handleGroupSelect(groupLabel, addAll) {
    const { value, options } = this.props;
    const group = options.find(ea => ea.label === groupLabel);

    const newValue = addAll
      ? withGroup(value, group)
      : withoutGroup(value, group);

    this.triggerChangeEvent(newValue);
  }

  triggerChangeEvent(value) {
    const { name, onChange } = this.props;
    const syntheticSyntheticEvent = {
      target: {
        value,
        name,
        type: 'groupselect',
        dataset: getDatasetFromProps(this.props),
      },
    };
    onChange(syntheticSyntheticEvent);
  }

  render() {
    const { value, options, onChange } = this.props;
    return (
      <MultiSelect
        components={{ GroupHeading, ValueContainer }}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        {...this.props}
        value={value}
        onChange={onChange}
        aggregateSelection={this.groupSelection(value, options)}
        onGroupSelect={this.handleGroupSelect}
      />
    );
  }
}

GroupSelect.propTypes = {
  value: arrayOf(string.isRequired),
  options: arrayOf(
    shape({
      label: string.isRequired,
      options: arrayOf(optionShape).isRequired,
    }),
  ).isRequired,
  readOnly: bool,

  name: string,
  onChange: func,
};

GroupSelect.defaultProps = {
  value: [],
  readOnly: false,

  name: '',
  onChange: () => {},
};

export default GroupSelect;
